import { MutationTree } from 'vuex';
import { ApiState } from './types';

export enum MutationTypes {
    INCREMENT_ON_GOING_REQUESTS = 'INCREMENT_ON_GOING_REQUESTS',
    DECREMENT_ON_GOING_REQUESTS = 'DECREMENT_ON_GOING_REQUESTS',
    SET_IS_INTENSIVE_USED_API = 'SET_IS_INTENSIVE_USED_API',
    SET_SERVER_HOST = 'SET_SERVER_HOST',
    SET_SERVICE_DOWN_INTERVAL_SHORT_EVAL = 'SET_SERVICE_DOWN_INTERVAL_SHORT_EVAL',
    SET_URL = 'SET_URL',
    SET_RESPONSE = 'SET_RESPONSE',
    UPDATE_DATA = 'UPDATE_DATA'
}

export type Mutations<S = ApiState> = {
    [MutationTypes.SET_IS_INTENSIVE_USED_API]: (state: S, isIntensiveUsedApi: boolean) => void,
    [MutationTypes.INCREMENT_ON_GOING_REQUESTS]: (state: S) => void,
    [MutationTypes.SET_SERVER_HOST]: (state: S, serverHost: string) => void,
    [MutationTypes.SET_SERVICE_DOWN_INTERVAL_SHORT_EVAL]: (state: S, serviceDownIntervalShortEval: number) => void,
    [MutationTypes.SET_URL]: (state: S, url: string) => void,
    [MutationTypes.SET_RESPONSE]: (state: S, url: string) => void,
    [MutationTypes.UPDATE_DATA]: (state: S, data: Object) => void
}

export const mutations: MutationTree<ApiState> = {
    [MutationTypes.SET_IS_INTENSIVE_USED_API]: (state, isIntensiveUsedApi) => {
        state.isIntensiveUsedApi = isIntensiveUsedApi;
    },
    [MutationTypes.INCREMENT_ON_GOING_REQUESTS]: (state) => {
        state.ongoingRequests += 1;
    },
    [MutationTypes.DECREMENT_ON_GOING_REQUESTS]: (state) => {
        state.ongoingRequests = Math.max(0, state.ongoingRequests - 1);
    },
    [MutationTypes.SET_SERVER_HOST]: (state, serverHost) => {
        state.serverHost = serverHost;
    },
    [MutationTypes.SET_SERVICE_DOWN_INTERVAL_SHORT_EVAL]: (state, serviceDownIntervalShortEval) => {
        state.serviceDownIntervalShortEval = serviceDownIntervalShortEval;
    },
    [MutationTypes.SET_URL]: (state, url) => {
        state.url = url;
    },
    [MutationTypes.SET_RESPONSE]: (state, response) => {
        state.response = response;
    },
    [MutationTypes.UPDATE_DATA]: (state, payload) => {
        state.data[payload.key] = payload.value;
    }
};